export const dgiContMapping = (productName) => {
  const map = new Map();

  map.set('DGI Contribution', 'DGI Contribution');
  map.set('DGI Aportaciones', 'DGI Contribution');

  return map.get(productName);
};
